import React from "react";
import { User, BadgeCheck, ShieldCheck, Star, Award } from "lucide-react";
import { TRUST } from "@/lib/api";

const ICONS = { user: User, "badge-check": BadgeCheck, "shield-check": ShieldCheck, star: Star, award: Award };

export function TrustBadge({ level = "unverified", size = "md", showLabel = true }) {
  const t = TRUST[level] || TRUST.unverified;
  const Icon = ICONS[t.icon] || User;
  const px = size === "sm" ? 13 : 15;
  const pad = size === "sm" ? "px-2 py-0.5 text-xs" : "px-3 py-1 text-sm";
  return (
    <span data-testid={`trust-badge-${level}`} className={`inline-flex items-center gap-1.5 rounded-full font-bold ${pad}`}
      style={{ color: t.color, backgroundColor: t.bg }}>
      <Icon size={px} strokeWidth={2.6} />
      {showLabel && (size === "sm" ? t.short : t.label)}
    </span>
  );
}
